/* =======================================
   TEMPLATE SETTINGS
   ======================================= */

import DateTimePicker from '../../../../../../atum-stock-manager-for-woocommerce/assets/js/src/components/_date-time-picker';
import ExportSettings from '../../config/_export-settings';
import Globals from './_globals';
import SmartForm from '../../../../../../atum-stock-manager-for-woocommerce/assets/js/src/components/_smart-form';
import { Switcher } from '../../../../../../atum-stock-manager-for-woocommerce/assets/js/src/components/_switcher';

export default class TemplateSettings {
	
	$form: JQuery;
	dateTimePicker: DateTimePicker;
	$recurringExportCheckbox: JQuery;
	$saveInServerCheckbox: JQuery;
	$sendByEmailCheckbox: JQuery;
	$formControlsWrapper: JQuery;
	
	newTemplate: boolean = false;

	constructor(
		private settings: ExportSettings,
		private globals: Globals,
	) {
		
		this.$form = this.globals.$summarySection.find('.settings-wrapper form');
		this.$recurringExportCheckbox = this.$form.find('#atum_recurring_export');
		this.$saveInServerCheckbox = this.$form.find('#atum_save_in_server');
		this.$sendByEmailCheckbox = this.$form.find('#atum_send_by_email');
		this.$formControlsWrapper = this.$form.find('.form-controls');
		this.dateTimePicker = new DateTimePicker(this.settings);
		
		this.prepareInputs();
		
		new SmartForm(this.$form, this.settings.get('atumPrefix'), '.settings-field');
		
		this.bindEvents();
		
	}
	
	/**
	 * Prepare the settings' form inputs
	 */
	prepareInputs() {
	
		// Add the switchers.
		Switcher.doSwitchers('.js-switch', {}, this.$form);
		
		// Add select2.
		this.globals.enhancedSelect.doSelect2( this.$form.find('.atum-select2') );
		
		// Add tooltips.
		this.globals.tooltip.addTooltips(this.$form);
		
		// Add dateTimePickers.
		this.dateTimePicker.addDateTimePickers( this.$form.find('.atum-datepicker') );
		
	}
	
	bindEvents() {
		
		this.$form
			
			// Listen for fields reset to defaults and fix the switchers positions.
			.on('atum-smart-form-reset-default', (evt: JQueryEventObject, $input: JQuery) => {
				if ($input.is(':checkbox') || $input.is(':radio')) {
					this.globals.fixSwitchers($input);
				}
			})
		
			// Show/Hide the Save Template button when needed.
			.on('change', '#atum_save_as_template', (evt: JQueryEventObject) => {
				
				const $checkbox: JQuery  = $(evt.currentTarget),
				      $submitBtn: JQuery = this.$form.find('#save_template');
				
				// If there is a loaded template, the field will be a hidden input and don't need to hide the button.
				if ( !$checkbox.is(':checkbox') ) {
					return false;
				}
				
				if ($checkbox.is(':checked') && this.$form.find(':input').filter('.dirty').length ) {
					$submitBtn.show();
				}
				else {
					$submitBtn.hide();
					this.$formControlsWrapper.find('.alert').remove();
				}
				
			})
		
			// Submit the settings via Ajax.
			.on('submit', (evt: JQueryEventObject) => {
				evt.preventDefault();
				this.newTemplate = false;
				this.validateSubmission();
			})
		
			// Save as new template.
			.on('click', '#save_new_template', (evt: JQueryEventObject) => {
				evt.preventDefault();
				this.newTemplate = true;
				this.validateSubmission();
			});
		
	}
	
	/**
	 * Validate the submission before saving the template settings
	 *
	 * @param {string} triggerName
	 */
	validateSubmission(triggerName: string = 'atum-export-save-template') {
	
		// The recurring export must have at least one of the two options checked (save in server or send by email).
		if (this.$recurringExportCheckbox.is(':checked') && !this.$saveInServerCheckbox.is(':checked') && !this.$sendByEmailCheckbox.is(':checked')) {
			
			this.globals.swal({
				title            : this.settings.get('chooseExportLocation'),
				text             : this.settings.get('exportNeedsLocation'),
				type             : 'warning',
				confirmButtonText: this.settings.get('ok'),
				allowOutsideClick: false,
			});
			
		}
		else {
			
			let errors: number = 0;
			
			// Check for any visible inputs that are required.
			this.$form.find(':input').filter(':visible').each( (index: number, elem: Element) => {
				
				const $input: JQuery       = $(elem),
				      $errorHolder: JQuery = $input.hasClass('atum-select2') ? $input.siblings('.select2-container') : $input;
				
				let value: string | number = $input.val();
				
				if (!$input.is(':required')) {
					return;
				}
				
				if (value === '') {
					$errorHolder.addClass('error');
					errors++;
				}
				else {
					$errorHolder.removeClass('error');
				}
				
			});
			
			if (errors > 0) {
				this.addError();
			}
			else {
				this.resetErrors();
				this.$form.find(':input').filter('.dirty').removeClass('dirty');
				this.$form.trigger(triggerName); // All the template data is being saved externally.
			}
			
		}
	
	}
	
	/**
	 * Add an error notice
	 */
	addError() {
		
		if (!this.$formControlsWrapper.find('.alert').length) {
			this.$formControlsWrapper.prepend(`<div class="alert alert-danger">${ this.settings.get('fixErrors') }</div>`);
		}
		
	}
	
	/**
	 * Reset all the errors
	 */
	resetErrors() {
		
		this.$formControlsWrapper.find('.alert').remove();
		this.$form.find('.error').removeClass('error');
		
	}
	
}


// WEBPACK FOOTER //
// ./assets/js/src/components/export-central/_template-settings.ts